export default {
  ans: {
    modal: {
      confirm: '确定',
      cancel: '取消'
    },
    cascader: {
      placeholder: '请选择',
      noMatch: '搜索无结果',
      noData: '暂无数据'
    },
    datepicker: {
      placeholder: '请选择日期',
      cancel: '取消',
      confirm: '确定',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      selectTime: '选择时间',
      startTime: '开始时间',
      endTime: '结束时间'
    },
    input: {
      placeholder: '请输入...'
    },
    page: {
      goto: '跳转至',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    poptip: {
      confirm: '确定',
      cancel: '取消'
    },
    select: {
      placeholder: '请选择',
      noMatch: '搜索无结果',
      noData: '暂无数据',
      search: '搜索'
    },
    table: {
      emptyText: '暂无数据'
    },
    timepicker: {
      clear: '清空',
      confirm: '确定',
      placeholder: '请选择时间'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js